/**
 * @file: WiredMessageReadersSheet.tsx
 *
 * State wrapper for the pure {@link MessageReadersSheet}: reads the
 * coordinator's read-by overlay (`messageReaders.readers$`) — `null` means
 * closed, an array means open on those (freshly-fetched) readers.
 */

import { useChatConversation } from '@euler/app/flows/chat/lib/conversation/context';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { FC, memo } from 'react';
import { MessageReadersSheet } from './MessageReadersSheet';

export const WiredMessageReadersSheet: FC = memo(() => {
  const { messageReaders } = useChatConversation().coordinator;
  const [readers] = useBehaviorSubject(messageReaders.readers$);
  return (
    <BottomPanel visible={readers !== null} onClose={messageReaders.close}>
      <MessageReadersSheet readers={readers ?? []} />
    </BottomPanel>
  );
});
